<template>
  <div>
    <MapModal
      :modalNode="modalNode"
      :title="title == 'add' ? '新增施工时区' : '编辑施工时区'"
      :close="close"
      :submitData="submitData"
      :submit="submit"
      id="timeBlock"
      class="newModelPosition hierarchy2"
    >
    </MapModal>
  </div>
</template>
<script>
const MapModal = () => import("@/components/common/mapModal/Index");
import {
  getDropDownList,
  getProjectBimModel,
  addBimConstructSimDetail,
  editBimConstructSimDetail,
} from "@/api/api";
// import * as mapWork from "@/components/tables/animation/constructionSimulation/map.js";
import * as mapWork from "@/components/tables/animation/constructionSimulation/map.js";
export default {
  name: "timeBlock",
  components: { MapModal },
  props: ["title", "sceneId", "timeBlockData", "getConstructionSimulationList"],
  data() {
    return {
      ifPhotoGraphic: false,
      flightData: [],
      modalNode: {
        timeBlock: {
          show: true, // 默认展示
          loading: false, // 加载loading
          width: "320px", // 宽度配置 默认450px
          height: `auto`, // 配置模态框中心高度
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // 模态框中心配置
          content: {
            type: "form",
            formData: {
              totalTime: {
                type: "daterange",
                title: "总时间",
                disabledDate: this.timeBlockData.parentTotalTime,
              },
              model: {
                type: "cascader",
                title: "选择模型",
                placeholder: "选择模型",
                disabled: true,
                change: this.modelChange,
                // propsValue: "title",
                options: [],
              },
              stype: {
                md: 24,
                type: "radio",
                title: "选择模式",
                disabled: false,
                selectCreate: true,
                input: this.positionTypeInput,
                options: [
                  {
                    name: "显示",
                    id: true,
                  },
                  {
                    name: "隐藏",
                    id: false,
                  },
                ],
              },
              component: {
                type: "cascader",
                title: "选择构件",
                placeholder: "选择构件",
                multiple: true,
                propsValue: "fullName",
                change: this.componentChange,
                options: [],
                checkStrictly: true,
              },
            },
            rules: {
              totalTime: [
                {
                  required: true,
                  message: "请选择",
                  trigger: "blur",
                },
              ],
              model: [
                {
                  required: true,
                  message: "请选择模型",
                  trigger: "blur",
                },
              ],
              component: [
                {
                  required: true,
                  message: "请选择构件",
                  trigger: "blur",
                },
              ],
            },
          },
        },
      },
      submitData: {
        totalTime: null,
        stype: true,
        model: null,
        component: null,
      },
    };
  },
  computed: {},
  watch: {},
  filters: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  methods: {
    close() {
      mapWork.init(this.submitData.model);
      this.$emit("close");
    },
    submit() {
      if (this.title == "add") {
        addBimConstructSimDetail({
          projectId: window.sessionStorage.getItem("nowProjectId"),
          groupId: this.timeBlockData.groupId,
          modelId: this.submitData.model,
          isShow: this.submitData.stype,
          startTime: this.submitData.totalTime[0],
          endTime: this.submitData.totalTime[1],
          units: JSON.stringify(this.submitData.component),
        })
          .then((res) => {
            let { code } = res.data;
            if (code == 200 || code == 204) {
              this.$notify({
                title: "添加成功",
                message: "",
                type: "success",
                duration: 960,
                offset: 320,
              });
              this.getConstructionSimulationList();
            } else {
              this.$notify({
                title: "添加失败",
                message: "",
                type: "error",
                duration: 1000,
                offset: 320,
              });
            }
          })
          .catch((error) => {
            this.$notify({
              title: "添加失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
          });
      } else {
        editBimConstructSimDetail({
          projectId: window.sessionStorage.getItem("nowProjectId"),
          id: this.timeBlockData.id,
          groupId: this.timeBlockData.groupId,
          modelId: this.submitData.model,
          isShow: this.submitData.stype,
          startTime: this.submitData.totalTime[0],
          endTime: this.submitData.totalTime[1],
          units: JSON.stringify(this.submitData.component),
        })
          .then((res) => {
            let { code } = res.data;
            if (code == 200 || code == 204) {
              this.$notify({
                title: "编辑成功",
                message: "",
                type: "success",
                duration: 960,
                offset: 320,
              });
              this.getConstructionSimulationList();
              mapWork.init(this.submitData.model);
            } else {
              this.$notify({
                title: "编辑失败",
                message: "",
                type: "error",
                duration: 1000,
                offset: 320,
              });
            }
          })
          .catch((error) => {
            this.$notify({
              title: "编辑失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
          });
      }
    },
    modelChange(e, isComponent) {
      if (isComponent == null) {
        this.submitData.component = [];
      }

      mapWork.addPreviewModel(e);
      let modelData = {
        projectId: window.sessionStorage.getItem("nowProjectId"),
        EMBSId: e,
      };
      getProjectBimModel(modelData).then((res) => {
        this.modalNode.timeBlock.content.formData.component.options = this.deleteEmptyChildren(
          res.data.data.dataList
        );
      });
    },
    componentChange(e) {
      console.log(this.processingComponentData(e));
      mapWork.componentDyeing(
        {
          component: this.processingComponentData(e),
        },
        this.submitData.model,
        this.submitData.stype ? "show" : "hide"
      );
    },

    deleteEmptyChildren(data) {
      if (data && data.length > 0) {
        data.forEach((item) => {
          if (item.children?.length == 0 && item.id != "-1") {
            delete item.children;
          } else {
            if (item?.bimModel?.fullName) {
              item.fullName = item.bimModel.fullName;
            }

            this.deleteEmptyChildren(item.children);
          }
        });
      }
      return data;
    },
    processingComponentData(e) {
      let bufferarr = [];
      let ifBufferarr;
      e.forEach((element) => {
        bufferarr.length == 0 && bufferarr.push(element);
        ifBufferarr = true;
        try {
          bufferarr.forEach((bufferaele) => {
            if (element.includes(bufferaele)) throw new Error();
          });
        } catch (err) {
          ifBufferarr = false;
        }
        if (ifBufferarr) bufferarr.push(element);
      });
      return bufferarr;
    },
    init() {
      if (this.title == "add") {
        this.submitData = {
          totalTime: null,
          stype: true,
          model: null,
          component: null,
        };
      } else {
        this.submitData.totalTime = this.timeBlockData.totalTime;
        this.submitData.stype = this.timeBlockData.stype;
        this.submitData.model = this.timeBlockData.model;
        this.submitData.component = this.timeBlockData.component;
      }

      let params = {
        projectId: window.sessionStorage.getItem("nowProjectId"),
        scenesId: this.sceneId,
      };
      getDropDownList(params).then((res) => {
        let { data } = res.data;
        console.log(this.modalNode);
        this.modalNode.timeBlock.content.formData.model.options =
          data[0].children.length > 0 ? this.deleteEmptyChildren(data) : data;
        this.modalNode.timeBlock.content.formData.model.disabled = false;
      });
      if (this.title == "edit") {
        this.modelChange(this.submitData.model, true);
        this.componentChange(this.submitData.component);
      }
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    flightData(newData) {
      this.submitData.cameraView = newData[0];
    },
  },
  destroyed() {},
};
</script>
<style lang="scss" scoped></style>
